import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import sv from './locales/sv.json'

export const languages = [
  { code: 'en', label: 'English' },
  { code: 'sv', label: 'Svenska' },
] as const

// Same storage key as v1, so a chosen language carries over.
const STORAGE_KEY = 'appLanguage'

function initialLanguage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'en' || stored === 'sv') return stored
  } catch {
    /* storage blocked: fall through to the browser language */
  }
  return navigator.language?.toLowerCase().startsWith('sv') ? 'sv' : 'en'
}

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, sv: { translation: sv } },
  lng: initialLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
  try {
    localStorage.setItem(STORAGE_KEY, lng)
  } catch {
    /* ignore */
  }
})
document.documentElement.lang = i18n.language

export default i18n
